export { default } from './Recaptcha';
